<template>
  <div class="col-12 mx-auto overflow-hidden">
    <h1 class="title">Kostenlose Maschinenbewertung</h1>
    <div class="col-12 mx-auto border-box">
      <div class="flex stage-container mb3 small-border-radius">
        <div class="formstage bgcolor1 pointer" @click="changeStep((step = 0))">
          <p class="formstage-text passed">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z"
                fill="#0176CD"
              />
            </svg>
            <span>Ihre Branche</span>
          </p>
          <span class="gray formstage-info">{{
            onboardingMachineBrancheDefault
          }}</span>
        </div>
        <div
          class="formstage bgcolor1 pointer"
          @click="changeStep((step = 100))"
        >
          <p class="formstage-text passed">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z"
                fill="#0176CD"
              />
            </svg>
            <span>Ihre Maschine</span>
          </p>
          <span class="gray formstage-info"
            >{{ onboardingMachineCategoryDefault }}<br />{{
              onboardingManufacturerDefault
            }}
            {{ onboardingMachineTypeDefault }}</span
          >
        </div>
        <div class="formstage bgcolor1">
          <p class="formstage-text passed">3. <span>Anschaffung</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">4. <span>Ihre Kontaktdaten</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">5. <span>Echtzeitbewertung</span></p>
        </div>
      </div>
      <div class="container">
        <div class="year-value-flex">
          <div class="year-box">
            <h2
              class="h-label"
              v-bind:class="{ error: notfilled }"
            >
              1. Baujahr
            </h2>
            <input-suggestion
              type="selection"
              event_name="machineyear_selected"
              v-bind:trigger_open="machineyear_trigger"
              v-bind:data_source="machineyear_trigger_array"
              placeholder="Baujahr der Maschine"
              css_class="forminput"
              :validInput="isValid"
              :disabled="false"
            ></input-suggestion>
          </div>
          <br/>
          <div
            class="value-box"
            :class="secondInputState ? 'disabledForminput' : ''"
          >
            <h2
              class="h-label"
              v-bind:class="{ error: notfilled }"
            >
              2. Netto-Anschaffungswert
            </h2>
            <input-suggestion
              type="price"
              event_name="nettoprice_selected"
              v-bind:trigger_open="nettoprice_trigger"
              v-bind:data_source="nettoprice_trigger_array"
              placeholder="Nettowert"
              css_class="forminput"
              :validInput="isValid"
              :storedData="onboardingMachineNetto"
              :disabled="secondInputState"
            ></input-suggestion>
          </div>
        </div>
        <div class="button-flexbox align-center">
          <div>
            <a class="zueruck" @click="changeStep((step = 100))">Zurück</a>
          </div>
          <div>
            <submit-button
            name="Bestätigen und weiter"
            :validInput="isValid"
            event_name="pre_submit_step_200"
          />
          </div>
        </div>
        <div class="mb4"></div>
      </div>
      <cta-support-element />
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import SubmitButton from "./SubmitButton.vue";
import InputSuggestion from "./InputSuggestion.vue";
import CTASupportElement from "./CTASupportElement.vue";

export default {
  name: "OnboardingStep02",
  props: {
    name: String,
    event_name: String,
    button_style: String,
    onboardingMachineBrancheDefault: String,
    onboardingMachineCategoryDefault: String,
    onboardingManufacturerDefault: String,
    onboardingMachineTypeDefault: String,
    onboardingMachineYearDefault: String,
  },
  data() {
    return {
      notfilled: false,
      debug: false,
      input: "",
      dataEvents: {
        machineyear_selected: false,
      },

      onboardingMachineCategory: "",
      onboardingManufacturer: "",
      onboardingMachineType: "",
      onboardingMachineYear: 0,
      onboardingMachineNetto: "",

      nettoprice_trigger: false,
      nettoprice_trigger_array: [],
      nettoprice_input_text: "",

      machineyear_trigger: false,
      machineyear_trigger_array: [],
      machineyear_input_text: "",

      secondInputState: true,
      isValid: false,
    };
  },
  created() {
    this.log("OnboardingStep02 created!");

    EventBus.$on("machineyear_selected", (payload) => {
      this.log("OnboardingStep02 Event received: machineyear_selected");
      this.machineyear_input_text = payload.input;

      if (this.machineyear_input_text != "") {
        for (let i = 0; i < this.machineyear_trigger_array.length; i++) {
          if (
            this.machineyear_trigger_array[i].val == this.machineyear_input_text
          ) {
            this.secondInputState = false;
            return true;
          } else {
            this.secondInputState = true;
          }
        }
      }

      if (this.machineyear_input_text == "") {
        this.secondInputState = true;
        this.isValid = false;
      } else {
        if (this.nettoprice_input_text != "") {
          this.isValid = true;
          this.secondInputState = false;
        }
      }
    });

    EventBus.$on("nettoprice_selected", (payload) => {
      this.log("OnboardingStep02 Event received: nettoprice_selected");
      this.nettoprice_input_text = payload.input;
      if (payload.input.length != 0) {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    });
    EventBus.$on("pre_submit_step_200", () => {
      console.log("pre_submit_step_200 received");
      if (this.nettoprice_input_text != "") {
        this.notfilled = false;
        EventBus.$emit("submit_step_200", {
          opportunities_year: this.machineyear_input_text,
          opportunities_nettoprice: this.nettoprice_input_text,
        });
      } else {
        // TODO: Alertbox nothing inserted!
        this.notfilled = true;
      }
    });

    EventBus.$on("evaluateNewMachine", () => {

      this.onboardingMachineCategory= "";
      this.onboardingManufacturer= "";
      this.onboardingMachineType= "";
      this.onboardingMachineYear= 0;
      this.onboardingMachineNetto= "";

      this.nettoprice_trigger= false;
      this.nettoprice_input_text= "";

      this.machineyear_trigger= false;
      this.machineyear_input_text= "";

      this.secondInputState= true;
      this.isValid= false;
    });

    var today = new Date();
    var currentYear = today.getFullYear();
    for (let i = currentYear; i >= 2009; i = i - 1) {
      this.machineyear_trigger_array.push({
        key: i,
        val: i,
      });
    }
    this.machineyear_trigger_array.push({
      key: "Älter",
      val: "Älter",
    });
  },
  components: {
    "submit-button": SubmitButton,
    "cta-support-element": CTASupportElement,
    "input-suggestion": InputSuggestion,
  },
  methods: {
    submit: function () {
      this.log(
        "OnboardingStep05.vue: Emitting Event using Submit: " + this.event_name
      );
      EventBus.$emit("" + this.event_name);
    },
    log: function (obj) {
      if (this.debug) {
        console.log(obj);
      }
    },
    changeStep(step) {
      EventBus.$emit("changeStep", {
        step_number: step,
      });
    },
  },
};
</script>

<style scoped>

svg {
  vertical-align: sub;
  margin-right: 10px;
}

.input-icon {
  position: absolute;
  right: 7px;
  top: 14px;
}

.year-box {
  width: 50%;
  margin-right: 3rem;
}
.year-value-flex {
  display: flex;
  margin-bottom: 3rem;
}

.manufacturer-box {
  width: 50%;
  margin-right: 3rem;
}

.value-box {
  width: 50%;
}

@media (max-width: 1060px) {

  .year-box {
    width: 100%;
    margin-right: 0;
  }
  .year-value-flex {
    flex-direction: column;
  }
  .manufacturer-box {
    width: 100%;
    margin-right: initial;
  }
  .value-box {
    width: 100%;
    margin-right: initial;
  }
}
</style>
